export * from './Main.page';
